module.exports = __webpack_public_path__ + "static/media/10_r_lampa_43.44_4.54.4b937b6b.png";